// extracted by mini-css-extract-plugin
export default {"fulfillmentSelector":"FulfillmentSelector-module__fulfillmentSelector___2beZo","pointer":"FulfillmentSelector-module__pointer___OkLQk"};